export const RuleTargetAffinity = {
    Exclusive: 1,
    Include: 2,
    Exclude: 3,
    ForbiddenRange: 4
};

export const OffsetReferencePoints = [
    { id: 1, name: 'Pouch Top' },
    { id: 2, name: 'Pouch Bottom' },
    { id: 3, name: 'Gusset Seal' },
    { id: 4, name: 'Hang Hole' },
    { id: 5, name: 'Tear Notch' },
    { id: 6, name: 'Valve' },
    { id: 7, name: 'Zipper' }
];

export const OffsetReferencePointNames = Object.fromEntries(OffsetReferencePoints.map(p => [p.id, p.name]));
